<template>
  <el-dropdown trigger="click" @command="handleSetSize">
    <div>
      <i class="iconfont iconziti" style="font-size:24px;"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="size==='medium'" command="medium">超大</el-dropdown-item>
      <el-dropdown-item :disabled="size==='small'" command="small">正常</el-dropdown-item>
      <el-dropdown-item :disabled="size==='mini'" command="mini">小型</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    size() {
      return this.$store.getters.size
    }
  },
  methods: {
    handleSetSize(size) {
      this.$ELEMENT.size = size
      this.$store.dispatch('setSize', size)
      this.refreshView()
      this.$message({
        message: '字体切换成功！',
        type: 'success'
      })
    },
    refreshView() {
      // 以使缓存的页面重新呈现
      this.$store.dispatch('delAllCachedViews', this.$route)

      const { fullPath } = this.$route

      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + fullPath
        })
      })
    }
  }

}
</script>

<style scoped>
.size-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -4px!important;
}
</style>




// WEBPACK FOOTER //
// src/components/SizeSelect/index.vue